import React, { useState, useRef, useEffect } from 'react';
import clsx from 'clsx';
import {
  Layers, ChevronDown, Coffee, LogOut, Sparkles,
  Timer, RadioTower, Zap, Activity, PhoneCall, Clock,
  Monitor, Globe
} from 'lucide-react';
import { useAgentContext } from '../../../../app/modules/apps/call/AgentContext';
import { useThemeMode } from '../../../partials/layout/theme-mode/ThemeModeProvider';

export const AgentControls = ({ className = '', dropUp = false, forceDark = false, variant = 'all' }: { className?: string, dropUp?: boolean, forceDark?: boolean, variant?: 'all' | 'timer-only' | 'no-timer' }) => {
  const isCompact = className?.includes('agent-compact');
  const {
    isLoggedIn, isAux, selectedCampaign, setSelectedCampaign,
    campaigns, auxReasons, seconds, handleLogin, handleLogout,
    handleAuxAction, data,
  } = useAgentContext() as any;

  const { mode } = useThemeMode();
  const isSystemDark = mode === 'dark' || document.documentElement.getAttribute('data-bs-theme') === 'dark';
  const isDark = forceDark || isSystemDark;

  const [telephonyMode, setTelephonyMode] = useState<'desktop' | 'web'>(() => {
    return (localStorage.getItem('telephony-device-mode') as 'desktop' | 'web') || 'desktop';
  });

  useEffect(() => {
    const modeHandler = (e: any) => {
      if (e?.detail) setTelephonyMode(e.detail);
    };
    window.addEventListener('telephony-device-mode-changed', modeHandler);
    return () => window.removeEventListener('telephony-device-mode-changed', modeHandler);
  }, []);

  const handleToggleTelephony = () => {
    const nextMode = telephonyMode === 'desktop' ? 'web' : 'desktop';
    setTelephonyMode(nextMode);
    localStorage.setItem('telephony-device-mode', nextMode);
    window.dispatchEvent(new CustomEvent('telephony-device-mode-changed', { detail: nextMode }));
  };

  const [showCampaignMenu, setShowCampaignMenu] = useState(false);
  const campaignBtnRef = useRef<HTMLButtonElement>(null);

  // Theme tokens — same as NavbarSoftphone
  const glass = isDark ? 'rgba(255,255,255,0.12)' : 'rgba(0,0,0,0.06)';
  const glassBorder = isDark ? '1px solid rgba(255,255,255,0.2)' : '1px solid rgba(0,0,0,0.12)';
  const txt = isDark ? '#ffffff' : '#1e293b';
  const muted = isDark ? 'rgba(255,255,255,0.65)' : 'rgba(30,41,59,0.50)';

  const formatTime = (s: number) => new Date(s * 1000).toISOString().substr(11, 8);
  const queueLen = data?.queue?.length || 0;

  return (
    <div className={clsx('d-flex align-items-center gap-2', className)}>
      {!isLoggedIn ? (
        /* ── PRE-LOGIN ── */
        // <div className="d-flex align-items-center rounded-3"
        //   style={{ background: glass, border: glassBorder, padding: '3px 4px 3px 8px' }}>

        //   {/* Campaign Picker */}
        //   {variant !== 'timer-only' && (
        //     <div className="position-relative me-1">
        //       {/* <button
        //       ref={campaignBtnRef}
        //       className="btn d-flex align-items-center gap-2 px-3 rounded-2 fw-semibold border-0"
        //       style={{ height: 30, background: 'transparent', color: txt, fontSize: 12 }}
        //       onClick={() => setShowCampaignMenu(!showCampaignMenu)}
        //     >
        //       <Layers size={13} style={{ color: muted }} />
        //       <span className="text-truncate" style={{ maxWidth: '130px', color: selectedCampaign !== 'Select Campaign' ? txt : muted }}>
        //         {selectedCampaign === 'Select Campaign' ? 'Pilih Campaign' : selectedCampaign}
        //       </span>
        //       <ChevronDown size={11} style={{ color: muted }} />
        //     </button> */}

        //       {showCampaignMenu && (
        //         <div
        //           className="position-absolute start-0 top-100 mt-2 rounded-4 py-2 animate__animated animate__fadeIn animate__faster"
        //           style={{ zIndex: 99999, minWidth: 280, background: isDark ? '#1e1e2d' : '#ffffff', boxShadow: '0 16px 48px rgba(0,0,0,0.22)', border: `1px solid ${isDark ? 'rgba(255,255,255,0.08)' : 'rgba(0,0,0,0.10)'}` }}
        //         >
        //           <div className="px-4 py-2" style={{ borderBottom: '1px solid var(--bs-border-color)' }}>
        //             <span className="fw-boldest text-uppercase text-muted" style={{ fontSize: 9, letterSpacing: '0.8px' }}>Available Campaigns</span>
        //           </div>
        //           <div style={{ maxHeight: 240, overflowY: 'auto' }}>
        //             {campaigns?.map((c: any, i: number) => {
        //               const cName = c.name || c.Name;
        //               const isCurrent = cName === selectedCampaign;
        //               return (
        //                 <div key={c.id || i}
        //                   className="d-flex align-items-center justify-content-between px-4 py-2 cursor-pointer"
        //                   style={{ background: isCurrent ? 'rgba(59,130,246,0.08)' : 'transparent' }}
        //                   onClick={() => { setSelectedCampaign(cName); setShowCampaignMenu(false); }}
        //                 >
        //                   <div className="d-flex align-items-center gap-2">
        //                     <div className="rounded-circle flex-shrink-0"
        //                       style={{ width: 7, height: 7, background: isCurrent ? '#3b82f6' : 'var(--bs-gray-400)' }} />
        //                     <span className="fw-semibold" style={{ fontSize: 13, color: isDark ? '#f4f4f5' : '#181c32' }}>{cName}</span>
        //                   </div>
        //                   {isCurrent && <span className="badge badge-sm badge-light-primary">Active</span>}
        //                 </div>
        //               );
        //             })}
        //           </div>
        //         </div>
        //       )}
        //     </div>
        //   )}

        //   {/* <div style={{ width: 1, height: 20, background: isDark ? 'rgba(255,255,255,0.18)' : 'rgba(0,0,0,0.12)' }} /> */}

        //   {/* <button
        //     className="btn d-flex align-items-center gap-2 fw-bold rounded-2 ms-1"
        //     style={{ height: 30, padding: '0 16px', fontSize: 12, background: 'linear-gradient(135deg, #3b82f6, #6366f1)', color: '#fff', border: 'none', boxShadow: '0 3px 12px rgba(99,102,241,0.35)' }}
        //     onClick={handleLogin}
        //   >
        //     <Sparkles size={12} />
        //     Mulai Shift
        //   </button> */}
        // </div>
        <div></div>
      ) : (
        /* ── LOGGED IN ── */
        <div className="d-flex align-items-center gap-2 animate__animated animate__fadeIn">

          {/* Campaign pill */}
          <div className="d-flex align-items-center gap-2 px-3 rounded-3"
            style={{ height: 34, background: isDark ? 'rgba(59,130,246,0.25)' : 'rgba(59,130,246,0.12)', border: isDark ? `1px solid rgba(147,197,253,0.4)` : `1.5px solid rgba(59,130,246,0.35)`, maxWidth: isCompact ? 44 : undefined, overflow: 'hidden' }}>
            <RadioTower size={12} style={{ color: isDark ? '#fff' : '#2563eb', flexShrink: 0 }} />
            {!isCompact && (
              <span className="fw-bold text-truncate" style={{ maxWidth: '110px', color: isDark ? '#fff' : '#2563eb', fontSize: 12 }}>
                {selectedCampaign}
              </span>
            )}
          </div>
          {/* We only render Campaign Picker if not timer-only */}
          {variant === 'timer-only' && null}


          {/* Timer pill */}
          {variant !== 'no-timer' && (
            <div className="d-flex align-items-center gap-2 px-3 rounded-3"
              style={{ height: 34, background: glass, border: glassBorder }}>
              <Timer size={13} style={{ color: muted }} />
              <span className="fw-bold font-monospace" style={{ fontSize: 12, color: txt, letterSpacing: '0.06em' }}>
                {formatTime(seconds)}
              </span>
            </div>
          )}

          {/* Queue pill */}
          {variant !== 'timer-only' && (<>
            <div className={clsx("dropdown", dropUp && "dropup")}>
              <button
                className="btn d-flex align-items-center gap-2 px-3 rounded-3 fw-semibold"
                style={{
                  height: 34, fontSize: 12,
                  background: queueLen > 0 ? 'rgba(239,68,68,0.12)' : glass,
                  border: queueLen > 0 ? '1.5px solid rgba(239,68,68,0.40)' : glassBorder,
                  color: queueLen > 0 ? (isDark ? '#fca5a5' : '#dc2626') : txt,
                }}
                data-bs-toggle="dropdown"
                data-bs-auto-close="outside"
              >
                <Activity size={13} className={queueLen > 0 ? 'animate__animated animate__pulse animate__infinite' : ''} />
                {!isCompact && <span>Antrean</span>}
                <span className="fw-boldest font-monospace" style={{ fontSize: 13 }}>{queueLen}</span>
              </button>
              <div className="dropdown-menu dropdown-menu-end p-0 border-0 rounded-4 overflow-hidden shadow-lg"
                style={{ zIndex: 99999, width: 340, boxShadow: '0 20px 60px rgba(0,0,0,0.22)' }}>
                <div className="px-5 py-4 d-flex justify-content-between align-items-center"
                  style={{ background: 'linear-gradient(135deg,#ef4444,#dc2626)' }}>
                  <div>
                    <div className="fw-boldest text-white fs-6">Waiting Callers</div>
                    <div className="text-white opacity-75 fs-9">Panggilan dalam antrean</div>
                  </div>
                  <span className="badge bg-white text-danger fw-bold rounded-pill px-3 py-2 fs-8">{queueLen} Waiting</span>
                </div>
                <div style={{ maxHeight: 260, overflowY: 'auto' }}>
                  {queueLen > 0 ? data.queue.map((d: any, idx: number) => (
                    <div key={idx} className="d-flex align-items-center p-4 border-bottom border-light">
                      <div className="d-flex align-items-center justify-content-center rounded-circle me-3 flex-shrink-0"
                        style={{ width: 40, height: 40, background: 'rgba(239,68,68,0.10)' }}>
                        <PhoneCall size={18} className="text-danger animate__animated animate__pulse animate__infinite" />
                      </div>
                      <div>
                        <div className="fw-bold text-body fs-7">{d.phone}</div>
                        <div className="d-flex align-items-center gap-1 text-muted fs-9">
                          <Clock size={10} /> Wait: <span className="text-danger fw-bold">{d.waitTime}</span>
                        </div>
                      </div>
                    </div>
                  )) : (
                    <div className="text-center py-8 px-4">
                      <div className="d-flex align-items-center justify-content-center rounded-circle mx-auto mb-3"
                        style={{ width: 52, height: 52, background: 'var(--bs-light)' }}>
                        <Coffee size={22} className="text-muted" />
                      </div>
                      <div className="fw-bold text-body fs-7 mb-1">Antrean Kosong</div>
                      <div className="text-muted fs-9">Tidak ada nasabah yang menunggu.</div>
                    </div>
                  )}
                </div>
              </div>
            </div>

            {/* Telephony Device Toggle (External Softphone vs Internal Softphone) */}
            <button
              className="btn d-flex align-items-center gap-2 px-3 rounded-3 fw-bold transition-all"
              style={{
                height: 34, fontSize: 12,
                background: telephonyMode === 'desktop' 
                  ? (isDark ? 'rgba(139,92,246,0.25)' : 'rgba(139,92,246,0.12)')
                  : (isDark ? 'rgba(59,130,246,0.25)' : 'rgba(59,130,246,0.12)'),
                border: telephonyMode === 'desktop'
                  ? (isDark ? '1px solid rgba(196,181,253,0.5)' : '1.5px solid rgba(139,92,246,0.45)')
                  : (isDark ? '1px solid rgba(147,197,253,0.5)' : '1.5px solid rgba(59,130,246,0.45)'),
                color: telephonyMode === 'desktop'
                  ? (isDark ? '#c4b5fd' : '#7c3aed')
                  : (isDark ? '#93c5fd' : '#2563eb'),
                boxShadow: telephonyMode === 'desktop' ? '0 3px 10px rgba(139,92,246,0.15)' : '0 3px 10px rgba(59,130,246,0.15)',
              }}
              onClick={handleToggleTelephony}
              title={telephonyMode === 'desktop' ? "Mode: External Softphone Aktif (Klik untuk beralih ke Internal Softphone)" : "Mode: Internal Softphone Browser Aktif (Klik untuk beralih ke External Softphone)"}
            >
              {telephonyMode === 'desktop' ? (
                <>
                  <Monitor size={13} />
                  {!isCompact && <span>External Softphone</span>}
                </>
              ) : (
                <>
                  <Globe size={13} />
                  {!isCompact && <span>Internal Softphone</span>}
                </>
              )}
            </button>

            {/* AUX — Bootstrap dropdown, no custom state needed */}
            <div className={clsx("dropdown", dropUp && "dropup")}>
              <button
                className="btn d-flex align-items-center gap-2 px-3 rounded-3 fw-bold"
                style={{
                  height: 34, fontSize: 12,
                  background: isAux ? (isDark ? 'rgba(245,158,11,0.25)' : 'rgba(245,158,11,0.12)') : (isDark ? 'rgba(16,185,129,0.25)' : 'rgba(16,185,129,0.12)'),
                  border: isAux ? (isDark ? '1px solid rgba(252,211,77,0.5)' : '1.5px solid rgba(245,158,11,0.45)') : (isDark ? '1px solid rgba(110,231,183,0.5)' : '1.5px solid rgba(16,185,129,0.45)'),
                  color: isAux ? (isDark ? '#fff' : '#b45309') : (isDark ? '#fff' : '#059669'),
                  boxShadow: isAux ? '0 3px 10px rgba(245,158,11,0.15)' : '0 3px 10px rgba(16,185,129,0.15)',
                }}
                data-bs-toggle="dropdown"
                data-bs-auto-close="outside"
              >
                {isAux
                  ? <><Coffee size={13} className="animate__animated animate__pulse animate__infinite" />{!isCompact && <span>On Break</span>}</>
                  : <><Zap size={13} />{!isCompact && <span>Available</span>}</>
                }
                <ChevronDown size={11} className="opacity-75" />
              </button>

              <div className="dropdown-menu dropdown-menu-end p-0 border-0 rounded-4 overflow-hidden"
                style={{ zIndex: 99999, minWidth: 260, boxShadow: '0 24px 64px rgba(0,0,0,0.20), 0 4px 16px rgba(0,0,0,0.10)', border: `1px solid ${isDark ? 'rgba(255,255,255,0.08)' : 'rgba(0,0,0,0.08)'}` }}>

                {/* Header */}
                <div className="px-5 py-4 d-flex align-items-center gap-3"
                  style={{ background: isAux ? 'linear-gradient(135deg,#f59e0b,#d97706)' : 'linear-gradient(135deg,#10b981,#059669)' }}>
                  <div className="d-flex align-items-center justify-content-center rounded-3 flex-shrink-0"
                    style={{ width: 38, height: 38, background: 'rgba(255,255,255,0.20)' }}>
                    {isAux ? <Coffee size={18} className="text-white" /> : <Zap size={18} className="text-white" />}
                  </div>
                  <div>
                    <div className="fw-boldest text-white" style={{ fontSize: 13 }}>
                      {isAux ? 'Sedang Break' : 'Status Aktif'}
                    </div>
                    <div className="text-white" style={{ fontSize: 11, opacity: 0.8 }}>
                      {isAux ? 'Pilih alasan atau kembali ke Available' : 'Pilih status break untuk istirahat'}
                    </div>
                  </div>
                </div>

                {/* Back to Available — only when on break */}
                {isAux && (
                  <button
                    className="btn d-flex align-items-center gap-3 fw-bold px-5 py-3 w-100 border-0"
                    style={{
                      fontSize: 13,
                      background: isDark ? 'rgba(16,185,129,0.10)' : 'rgba(16,185,129,0.06)',
                      color: isDark ? '#34d399' : '#059669',
                      borderBottom: `1px solid ${isDark ? 'rgba(255,255,255,0.06)' : 'rgba(0,0,0,0.06)'}`,
                      borderRadius: 0,
                    }}
                    onClick={() => handleAuxAction(null)}
                  >
                    <div className="d-flex align-items-center justify-content-center rounded-3 flex-shrink-0"
                      style={{ width: 32, height: 32, background: isDark ? 'rgba(16,185,129,0.20)' : 'rgba(16,185,129,0.12)' }}>
                      <Zap size={15} />
                    </div>
                    Kembali ke Available
                  </button>
                )}

                {/* Section Label */}
                <div className="px-5 pt-3 pb-2">
                  <span className="fw-boldest text-uppercase text-muted" style={{ fontSize: 9, letterSpacing: '1px' }}>
                    Alasan Break
                  </span>
                </div>

                {/* AUX Reason List */}
                <div style={{ maxHeight: 240, overflowY: 'auto', paddingBottom: 8 }}>
                  {auxReasons?.map((r: any, i: number) => {
                    const colors = [
                      { bg: 'rgba(245,158,11,0.12)', color: '#d97706', icon: '#f59e0b' },
                      { bg: 'rgba(99,102,241,0.10)', color: '#6366f1', icon: '#818cf8' },
                      { bg: 'rgba(59,130,246,0.10)', color: '#2563eb', icon: '#60a5fa' },
                      { bg: 'rgba(236,72,153,0.10)', color: '#db2777', icon: '#f472b6' },
                      { bg: 'rgba(16,185,129,0.10)', color: '#059669', icon: '#34d399' },
                      { bg: 'rgba(239,68,68,0.10)', color: '#dc2626', icon: '#f87171' },
                    ];
                    const c = colors[i % colors.length];
                    return (
                      <button
                        key={r.id}
                        className="btn d-flex align-items-center gap-3 text-start fw-semibold px-5 py-2 border-0 bg-transparent w-100 transition-all"
                        style={{ fontSize: 13, color: 'var(--bs-body-color)', borderRadius: 0 }}
                        onClick={() => handleAuxAction(r.id)}
                      >
                        <div className="d-flex align-items-center justify-content-center rounded-3 flex-shrink-0"
                          style={{ width: 32, height: 32, background: c.bg }}>
                          <Coffee size={14} style={{ color: c.icon }} />
                        </div>
                        <span>{r.reasonName}</span>
                      </button>
                    );
                  })}
                </div>
              </div>
            </div>

            {/* Logout */}
            <button
              className="btn d-flex align-items-center justify-content-center rounded-2"
              style={{ width: 34, height: 34, padding: 0, background: 'rgba(239,68,68,0.10)', border: `1.5px solid rgba(239,68,68,0.30)`, color: isDark ? '#fca5a5' : '#dc2626' }}
              onClick={handleLogout}
              title="Logout Shift"
            >
              <LogOut size={14} />
            </button>
          </>)}
        </div>
      )}
    </div>
  );
};
